import './../../scss/blocks/_cookie.scss'
import cookieBanner from '../components/consentBanner'

document.addEventListener('DOMContentLoaded', () => {
    cookieBanner()
})
